export const engineCollection = ['engine-type'];
export const performanceCollectionCombustion = [
    'max-output',
    'max-output-kw',
    'max-output-ps',
    'max-output-extra-max-output',
    'top-speed',
    'acceleration',
    'acceleration-mlc',
];
export const performanceCollectionElectric = [
    'electrical-power',
    'max-electrical-power-mlc',
    'top-speed',
    'acceleration',
    'acceleration-mlc',
];
export const performanceCollectionHybrid = [
    'max-output',
    'max-output-kw',
    'top-speed',
    'acceleration',
    'acceleration-mlc',
];
export const technicalDataCollectionElectric = [
    'electrical-torque',
    'max-torque-front-back',
    'battery-type',
    'battery-energy-content-gross',
    'battery-energy-content-net',
    'hybrid-total-system-torque',
    'electrical-power',
    'max-electrical-power-mlc',
    'max-loading-power',
    'battery-charging-ac-100',
    'battery-charging-dc-10-80',
    'max-range-charging-dc-10',
    'max-30-min-power',
];
export const technicalDataCollectionHybrid = [
    'electrical-torque',
    'max-torque-front-back',
    'hybrid-total-system-torque',
    'battery-type',
    'battery-energy-content-gross',
    'battery-energy-content-net',
    'hybrid-electrical-power',
    'max-loading-power',
    'battery-charging-ac-100',
    'battery-charging-dc-10-80',
];
export const technicalDataCollectionCombustion = [
    'displacement',
    'max-torque',
    'emission-control-system',
    'engine-management',
    'fuel-type',
];
export const drivelineCollection = ['transmission-type', 'gearbox', 'clutch'];
export const landingGearCollection = ['front-axle', 'rear-axle'];
export const brakeSystemCollection = ['brakes'];
export const steeringSystemCollection = ['steering'];
export const weightsCollection = ['unladen-weight', 'gross-weight-limit'];
export const roofLoadCollection = ['roof-load'];
export const tongueLoadCollection = ['tongue-weight'];
export const trailerWeightCollection = [
    'trailer-weight-limit-unbraked',
    'trailer-weight-limit-gradient12',
    'trailer-weight-limit-gradient8',
];
export const consumptionCollection = ['fuel-type'];
export const volumeCollection = ['luggage-compartment-capacity', 'tank-capacity'];
export const noiseCollection = ['noise-level-driving'];
export const insuranceCollection = [
    'comprehensive-insurance-class',
    'partial-coverage-insurance-class',
    'liability-insurance-class',
];
export const emissionCollection = [
    'consumption-combined',
    'consumptionDischarged',
    'electric-consumption-combined',
    'emissionCO2',
    'eec',
    'eecDischarged',
    'efficiency-class',
    'emission-class',
    'electric-range',
    'emissionNOx',
    'fueltype',
];
export const emissionCollectionPHEV = [
    'consumption-combined',
    'consumptionDischarged',
    'electric-consumption-combined',
    'emissionCO2',
    'eec',
    'eecDischarged',
    'efficiency-class',
    'emission-class',
    'electric-range',
    'electric-range-city',
    'emissionNOx',
    'fueltype',
];
